import { gql } from '@root/gql/utils/gql';

export const getEventsQuery = gql`
  query GetEvents($dto: GetEventsDto!) {
    events(dto: $dto) {
      data {
        categoryIds
        dateTime
        createdAt
        deletedAt
        additionalContent
        id
        images {
          imageUrl
          priority
        }
        isPublished
        language
        mainImageUrl
        name
        offerPrice {
          discountedPrice
          discountName
          fullPrice
        }
        onlyByUri
        options {
          createdAt
          deletedAt
          id
          language
          name
          offerPrice {
            discountedPrice
            discountName
            fullPrice
          }
          price
          updatedAt
        }
        price
        purchaseLimit
        settings {
          createdAt
          deletedAt
          id
          productId
          productLevelQuantity
          quantityLevelSetting
          redemptionValidityPeriodMonths
          salesGeneratedByThirdParties
          updatedAt
        }
        briefDescription
        termsAndConditions
        type
        updatedAt
      }
      meta {
        currentPage
        finalPage
        limitPerPage
        total
      }
    }
  }
`;
